export default __webpack_public_path__ + "static/media/full_buysellapp_logo.c5a7292e.png";